import logo from './logo.svg';
import './App.css';
import Marquee from "react-fast-marquee";

export default function App() {
  const images = [{
    src: "https://info.soluzionemeeting.com/static/sm/il-sole-24-ore.png",
    alt: "Il Sole 24 Ore",
    height: "8rem",
  }, {
    src: "https://info.soluzionemeeting.com/static/sm/forbes-italia.png",
    alt: "Forbes Italia",
    height: "6rem",
  }, {
    src: "https://info.soluzionemeeting.com/static/sm/yahoo-finance.png",
    alt: "Yahoo! Finance",
    height: "3rem",
  }, {
    src: "https://info.soluzionemeeting.com/static/sm/wall-street-italia.png",
    alt: "Wall Street Italia",
    height: "3rem",
  }, {
    src: "https://info.soluzionemeeting.com/static/sm/ask-news.png",
    alt: "Ask! News",
    height: "3rem",
  }, {
    src: "https://info.soluzionemeeting.com/static/sm/milano-finanza.png",
    alt: "Milano Finanza",
    height: "3rem",
  }, {
    src: "https://info.soluzionemeeting.com/static/sm/adnkronos.png",
    alt: "Adnkronos",
    height: "3rem",
  }, {
    src: "https://info.soluzionemeeting.com/static/sm/la-repubblica.png",
    alt: "La Repubblica",
    height: "3rem",
  }];

    return (
      <div className="w-full h-full flex flex-col items-center justify-center">
        <div className="relative flex overflow-x-hidden">
          <Marquee autoFill={true} className="whitespace-nowrap marquee" s>
            {images.map((image) => (
              <img src={image.src} alt={image.alt} style={{
                height: image.height,
                marginLeft: '22px'
              }} className={`inline-block ${image.height} mx-2`} />
            ))}
          </Marquee>
        </div>
      </div>
    );
}
